import { DateFnsLocaleProvider } from '@if/core/date'
import i18n, { initializeI18N } from '@if/core/i18n'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRoot } from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { I18nextProvider } from 'react-i18next'
import initializeGTM from './GTagManager'
import App from './containers/App/App'
import './containers/App/App.css'
import './index.css'
import initializeAppInsights from './services/AppInsights'
import { reportErrorToConsole, setupTracking } from './services/error-logger'

const ai = initializeAppInsights()
setupTracking(ai)
initializeGTM()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const container = document.getElementById('root')
const root = createRoot(container!)

initializeI18N()
  .then(() => {
    root.render(
      <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_CAPTCHA_SITE_KEY || ''}>
        <I18nextProvider i18n={i18n}>
          <QueryClientProvider client={queryClient}>
            <DateFnsLocaleProvider>
              <App />
              <div
                style={{
                  fontSize: '16px',
                }}
              >
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
              </div>
            </DateFnsLocaleProvider>
          </QueryClientProvider>
        </I18nextProvider>
      </GoogleReCaptchaProvider>,
    )
  })
  .catch(reportErrorToConsole)
